import React from 'react'
import PropTypes from 'prop-types'

import {List, ListItem, Badge} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'

// Others
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const BottomLinkedCategories = ({categories = [], onSelect = noop}) => {
    if (categories.length === 0) {
        return null
    }

    return (
        <List display="flex" justifyContent="center" flexWrap="wrap" rowGap="20px" columnGap="20px">
            {categories?.map(({id, displayName}) => {
                return (
                    <ListItem key={id}>
                        <Link
                            display="block"
                            href={`/category/${id}`}
                            onClick={onSelect}
                            useNavLink
                        >
                            <Badge
                                bg="#F5F8FD"
                                color="black"
                                textStyle="bodySmall"
                                fontSize="sm"
                                fontWeight={400}
                                px="10px"
                                py="4px"
                                borderRadius="0"
                                textTransform="none"
                            >
                                {displayName}
                            </Badge>
                        </Link>
                    </ListItem>
                )
            })}
        </List>
    )
}

BottomLinkedCategories.propTypes = {
    categories: PropTypes.array,
    onSelect: PropTypes.func
}

export default BottomLinkedCategories
